<script>
  import { config } from "./config";
  import {
    g_tabs,
    g_darkTheme,
    g_showLineNumbers,
    g_tree_content
  } from "./common.js";
  import Folder from "./Folder.svelte";
  import TabPanel from "./TabPanel.svelte";
  import TabHeader from "./TabHeader.svelte";
  import { onMount } from "svelte";

  let pjconfig, tree, tree_content;

  onMount(async () => {
    const urlParams = new URLSearchParams(window.location.search);
    let pjpath = urlParams.has("pj") ? urlParams.get("pj") : "empty";
    await fetch(`projects/${pjpath}/pjconfig.json`)
      .then(res => res.json())
      .catch(() => (pjpath = "empty"));
    let res = await fetch(`projects/${pjpath}/pjconfig.json`);
    pjconfig = await res.json();
    // g_pjconfig.set(pjconfig);
    res = await fetch(`projects/${pjpath}/tree.json`);
    tree = await res.json();
    // g_tree.set(tree);
    res = await fetch(`projects/${pjpath}/tree_content.json`);
    tree_content = await res.json();
    g_tree_content.set(tree_content);

    document.title += ` - ${pjpath}`;
  });

  let isMouseDown = false;
  let containerwidth = 0;
  let darkTheme = false;
  let showLineNumbers = true;
  export let newcontent = "";

  const mouseDown = e => {
    var x = e.clientX;
    var y = e.clientY;
    isMouseDown = true;
    containerwidth = document.getElementsByClassName("fullscreen")[0]
      .offsetWidth;
  };

  const mouseMove = e => {
    if (!isMouseDown) return;
    var x = e.clientX;
    var y = e.clientY;
    for (let i = 0; i < document.getElementsByClassName("left").length; i++) {
      document.getElementsByClassName("left")[i].style.width =
        (x / containerwidth) * 100 + "%";
      document.getElementsByClassName("middle")[i].style.width =
        99.5 - (x / containerwidth) * 100 + "%";
    }
  };

  const mouseUp = e => {
    isMouseDown = false;
  };
  const mouseOut = () => {
    isMouseDown = false;
  };

  const displayContent2 = path => {
    tree_content()[0].map(obj => {
      if (obj.path === path.detail.detail) {
        newcontent = obj.content;
        return false;
      }
    });
  };

  const unsubscribe_darkTheme = g_darkTheme.subscribe(
    value => (darkTheme = value)
  );
  const unsubscribe_showLineNumbers = g_showLineNumbers.subscribe(
    value => (showLineNumbers = value)
  );
  const setTheme = () => {
    darkTheme = !darkTheme;
    g_darkTheme.set(darkTheme);
  };
  const setLineNumbers = () => {
    showLineNumbers = !showLineNumbers;
    g_showLineNumbers.set(showLineNumbers);
  };
  const closeAllTabs = () => g_tabs.set([]);
  const openBtnLink = url => {
    window.open(url, "_blank");
  };
</script>

<style>
  button {
    background-color: rgb(85, 85, 85);
    color: white;
    cursor: pointer;
    border: none;
    outline: auto;
    padding: 2px;
  }
  button > img {
    width: 20px;
    height: 20px;
  }
  .btnright {
    margin: 0 1px;
    float: right;
  }
  .btnright > img {
    width: 20px;
    height: 20px;
  }
</style>

<div>
  {#if pjconfig && tree && tree_content}
    <div
      class="fullscreen"
      on:mouseup={mouseUp}
      on:mousemove={mouseMove}
      on:mouseleave={mouseOut}>
      <header
        class="w3-large"
        title={`content updated on ${pjconfig.datetime}`}>
        {pjconfig.title}
        <span class="w3-small" title="Copyright 2019">
          Source Code Viewer by
          <a href={config.links.myportfolio}>{config.header_right}</a>

        </span>
      </header>
      <div class="header">
        <div class="left">
          {#each pjconfig.btn_links as btnlink}
            <button
              on:click={() => {
                openBtnLink(btnlink.url);
              }}>
              <img
                src={btnlink.icon}
                title={btnlink.tooltip}
                alt={btnlink.tooltip} />
            </button>
          {/each}

          <button class="btnright" on:click={closeAllTabs}>
            <img
              src="./img/close_all_tabs.png"
              title="Close all tabs"
              alt="Close all tabs" />
          </button>
          <button class="btnright" on:click={setTheme}>
            <img
              src={darkTheme ? './img/colors_black.png' : './img/colors_white.png'}
              title="Toggle theme"
              alt="Toggle theme" />
          </button>
          <button class="btnright" on:click={setLineNumbers}>
            <img
              src={showLineNumbers ? './img/numbered_white.png' : './img/unnumbered_white.png'}
              title="Show line numbers"
              alt="Show line numbers" />
          </button>
        </div>
        <div class="middle">
          <TabHeader />
        </div>
      </div>
      <main>
        <div class="left">
          <div
            class="w3-container w3-cell m-0"
            style="height:
            100%;width:23%;white-space:nowrap;overflow:hidden;text-overflow:
            clip; ">
            {#if tree.length > 0}
              <Folder
                name={tree[0].name}
                children={tree[0].children}
                expanded />
            {/if}
          </div>
        </div>
        <div class="w3-teal w3-cell v_separator" on:mousedown={mouseDown} />
        <div class="middle">
          <div class="w3-container w3-yellow w3-cell " style="padding:0">
            <TabPanel />
          </div>
        </div>
      </main>
    </div>
  {:else}
    <p>Loading.....</p>
  {/if}
</div>
